export const trapFocus = (e, selector, focusableElements) => {
	if (e.key !== `Tab`) return;

	const modal = document.querySelector(selector);
	if (!modal) return;

	// get focusable elements in modal
	const focusableContent = modal.querySelectorAll(focusableElements);

	if (focusableContent.length === 0) {
		// No focusable elements, prevent tabbing out of modal
		e.preventDefault();
		return;
	}

	const firstFocusableElement = focusableContent[0];
	const lastFocusableElement = focusableContent[focusableContent.length - 1];

	if (e.shiftKey) {
		if (
			document.activeElement === firstFocusableElement ||
			!modal.contains(document.activeElement)
		) {
			lastFocusableElement.focus();
			e.preventDefault();
		}
	} else if (
		document.activeElement === lastFocusableElement ||
		!modal.contains(document.activeElement)
	) {
		firstFocusableElement.focus();
		e.preventDefault();
	}
};

export const addTrapFocusListener = (
	context,
	{
		selector,
		focusableElements = `button, a[href], area[href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])`
	}
) => {
	context.trapFocusTriggerElement = document.activeElement;

	const handleTrapFocus = e => {
		return trapFocus(e, selector, focusableElements);
	};

	context.addEventListener(document.body, `keydown`, handleTrapFocus);
};

export const removeTrapFocusListener = (context, skipFocus = true) => {
	if (!context) return;

	context.removeEventListener(document.body, `keydown`);
	if (!skipFocus) {
		context.trapFocusTriggerElement?.focus();
	}
	context.trapFocusTriggerElement = null;
};
